/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Spacing } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledVerticalFlow = styled.div`
  &:not(:first-of-type) {
    margin: ${Spacing.Small} 0 0;
  }
  text-align: ${props => props.align || 'left'};
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledVerticalFlow/index.js